// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"11":"8eb61f54","66":"d8384781","173":"6d9b8419","660":"cd1c0550","812":"11707484","891":"1f797826"}[chunkId] + ".chunk.css";
};